import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h-2l9 -9l9 9h-2","key":"svg-0"}],["path",{"d":"M5 12v7a2 2 0 0 0 2 2h5","key":"svg-1"}],["path",{"d":"M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2","key":"svg-2"}],["path",{"d":"M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5","key":"svg-3"}]]

const IconHomeSpark = createReactComponent('outline', 'home-spark', 'HomeSpark', __iconNode);

export default IconHomeSpark;